import Vue from 'vue/dist/vue.esm'

Vue.directive('capitalize', {
    inserted(el) {
        el.addEventListener('blur', () => {
            let value = el.value;
            if (value) {
                // Lowercase everything first
                value = value.toLowerCase();

                // Capitalize only the first letter of each word (Unicode-safe)
                value = value.replace(/(^|\s)([a-z\u00C0-\u017F])/g, (match, space, char) =>
                    space + char.toUpperCase()
                );

                el.value = value;
                el.dispatchEvent(new Event('input')); // update v-model
            }
        });
    }
});
